import { useEffect, useRef, useState } from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DraggableFeatureList from "../../../components/UI/DraggableFeatureList";
import { useSettings } from "../../../context/SettingsContext";
import { addUid } from "../../../utils/featureUid";

export default function LeadFeatures({ data }) {
  const [features, setFeatures] = useState([]);
  const { updateLeadFeatures } = useSettings();

  const hydrated = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    if (!data || hydrated.current) return;
    setFeatures((data.features || []).map(addUid));
    hydrated.current = true;
  }, [data]);

  const toggle = (uid, field = "enabled", value) => {
    dirty.current = true;
    setFeatures((p) =>
      p.map((i) => (i.uid === uid ? { ...i, [field]: value ?? !i[field] } : i)),
    );
  };

  const reorder = (column, newOrderIds) => {
    dirty.current = true;

    setFeatures((prev) =>
      prev.map((item) => {
        const newOrderIndex = newOrderIds.indexOf(item.uid);

        if (newOrderIndex !== -1) {
          return {
            ...item,
            position: column,
            order: newOrderIndex,
          };
        }

        return item;
      }),
    );
  };

  useEffect(() => {
    if (!dirty.current) return;
    updateLeadFeatures({
      features: features.map(({ uid, ...f }) => f),
      sources: data.sources,
    });
  }, [features]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 2.5 }}>
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
          Lead Profile Layout
        </Typography>
        <Tooltip title="Configure the layout of the lead profile page" arrow>
          <InfoOutlinedIcon sx={{ fontSize: 16, color: "#94a3b8", cursor: "pointer" }} />
        </Tooltip>
      </Box>

      <DraggableFeatureList
        items={features}
        getId={(i) => i.uid}
        onToggle={toggle}
        onReorder={reorder}
      />
    </Box>
  );
}
